import { Icon, IconProps } from '@/lib/ui-kit/icons';
import { cn } from '@/lib/ui-kit/utils';

type InfoIconProps = Omit<IconProps, 'name'>;

export function InfoIcon({ className, ...props }: InfoIconProps) {
  return (
    <Icon
      className={cn('text-muted-foreground ml-1 inline-block', className)}
      name={'Info'}
      {...props}
    />
  );
}
